import {
  AI_BRAIN_LEGACY_STOPPED_REPLY,
  AI_BRAIN_TOKEN_EXPIRED_DETAIL,
  AI_LLM_UNAVAILABLE_REPLY_MARKERS,
  AIConversationGenerationStatus,
  AIConversationMessageEventCode,
  AIConversationStopOutcome,
} from '../constants/aiAgents'

import { isApiUnauthorizedStatus } from './api'

export function isServiceUnavailableReply(text) {
  if (!text) {
    return false
  }

  const normalized = text.toLowerCase()

  return AI_LLM_UNAVAILABLE_REPLY_MARKERS.some(marker =>
    normalized.includes(marker)
  )
}

export function isLegacyStoppedReply(text) {
  return text?.trim() === AI_BRAIN_LEGACY_STOPPED_REPLY
}

export function isAIBrainTokenExpiredError(reason) {
  return (
    isApiUnauthorizedStatus(reason?.response?.status) &&
    reason?.response?.data?.detail === AI_BRAIN_TOKEN_EXPIRED_DETAIL
  )
}

export function getAIConversationGenerationStatus(response) {
  return response?.data?.generation_status ?? null
}

export function isAIConversationGenerationRunning(response) {
  return isAIConversationGenerationStatusRunning(
    getAIConversationGenerationStatus(response)
  )
}

export function isAIConversationGenerationFailed(response) {
  return (
    getAIConversationGenerationStatus(response) ===
    AIConversationGenerationStatus.Failed
  )
}

export function isAIConversationGenerationStatusRunning(status) {
  return status === AIConversationGenerationStatus.Running
}

export function hasAIConversationPendingAnswers(response) {
  return response.data.length > 0
}

// Oldest-first per the contract — the oldest open document read is the one worth naming.
export function getAIConversationPendingAnswerFileName(response) {
  return response?.data?.[0]?.filename ?? null
}

export function getAIConversationMessageEventCode(message) {
  return message?.event_code ?? null
}

export function isAIConversationMessageFailed(message) {
  return (
    getAIConversationMessageEventCode(message) ===
    AIConversationMessageEventCode.Failed
  )
}

export function isAIConversationMessageEvent(message) {
  return Boolean(getAIConversationMessageEventCode(message))
}

export function getAIStopTurnOutcome(response) {
  return response?.data?.status ?? null
}

export function isAIStopTurnRequested(response) {
  return (
    getAIStopTurnOutcome(response) === AIConversationStopOutcome.StopRequested
  )
}
